import { useCallback } from 'react'
import Styles from './style.module.scss'
import InputField from '@Molecule/InputField'

export default function SkillTestSection({
  form,
  setForm
}) {

  const handleChangeForm = useCallback((name, newVal, childName, id) => {
    if (!childName) {
      setForm(prev => {
        return {
          ...prev,
          [name]: newVal
        }
      })
    } else {
      setForm(prev => {
        return {
          ...prev,
          [name]: prev[name]?.map(obj => {
            if (obj?.id === id) {
              return {
                ...obj,
                [childName]: newVal
              }
            } else {
              return obj
            }
          })
        }
      })
    }

  }, [setForm])



  return (
    <div className={Styles.container}>
      <div className={Styles.header}>
        <h3>Uji Keterampilan</h3>
        <span>Unggah panduan untuk menjelaskan bagaimana cara dan tujuan peserta mengikuti Uji Keterampilan kelas Anda</span>
      </div>
      <div className={Styles.content}>
        <InputField
          title={'Panduan Uji Keterampilan'}
          value={form?.guide}
          setValue={(newVal) => handleChangeForm('guide', newVal)}
          isFile
          isPDFOnly
          speed={30}
          placeholder='Pilih file untuk panduan uji keterampilan'
          remark='Hanya mendukung file .jpg, .jpeg, .Mp4, dan .pdf'
          required
        />
        <InputField
          title={'Deskripsi'}
          value={form?.description}
          setValue={(newVal) => handleChangeForm('description', newVal)}
          placeholder='Deskripsi panduan'
          required
        />
      </div>
    </div>
  )
}